import { Box } from '@mui/material';
import { reusableStyles } from 'ui-blocks/ReusableStyles';
import BaseTypography from 'components/typography/BaseTypography';
import React from 'react';
import { ReactComponent as GreatBritain } from 'assets/svg/great-britain.svg';
import { ReactComponent as Spain } from 'assets/svg/spain.svg';
import { ReactComponent as France } from 'assets/svg/france.svg';
import { ReactComponent as Russia } from 'assets/svg/russia.svg';
import { ReactComponent as Brazil } from 'assets/svg/brazil.svg';
import { ReactComponent as India } from 'assets/svg/india.svg';
import { ReactComponent as Japan } from 'assets/svg/japan.svg';
import { ReactComponent as Saudi } from 'assets/svg/saudi.svg';
import { ReactComponent as China } from 'assets/svg/china.svg';
import { ReactComponent as Germany } from 'assets/svg/germany.svg';
import { ReactComponent as Netherlands } from 'assets/svg/netherland-antilles.svg';
import { landingPageStyles } from 'layouts/pages/landing-page/landingPageStyles';
import CharacterNarratorVideo from './components/CharacterNarratorVideo';
import { narratorSectionStyles } from './narratorSectionStyles';

export default function CharacterNarratorSection() {
	return (
		<Box id="characters-narrator-section" sx={[narratorSectionStyles.mainContainer]}>
			<CharacterNarratorVideo />
			<Box sx={[reusableStyles.flexRow, { width: { xs: '100%', mobileUi: '35%', xxl: '45%' } }]}>
				<Box
					id="characters-narrator-description"
					sx={[landingPageStyles.sectionDescriptionContainer]}
				>
					<BaseTypography
						variant="h2_zodiak"
						styles={{ color: 'colors.light3', textAlign: 'left' }}
					>
						Give Your AI Characters a Voice. Narrate Any Story.{' '}
					</BaseTypography>
					<Box sx={[reusableStyles.flexColWithGap(16)]}>
						<BaseTypography
							variant="b2_regular"
							styles={{
								color: 'colors.light3',
								fontSize: { xl: '14px' },
								lineHeight: { xl: '24px' },
							}}
						>
							Bring your scripts to life with AI characters that can narrate in 25+ languages —
							perfect for global marketing, ads, and storytelling.
						</BaseTypography>
						<Box id="countries-flag" sx={[narratorSectionStyles.flagContainer]}>
							<GreatBritain />
							<Spain />
							<France />
							<Russia />
							<Brazil />
							<India />
							<Japan />
							<Saudi />
							<China />
							<Germany />
							<Netherlands />
							<BaseTypography
								variant="b1_v2_regular"
								styles={{ color: 'colors.light3', textAlign: 'center' }}
							>
								and many more
							</BaseTypography>
						</Box>
					</Box>
				</Box>
			</Box>
		</Box>
	);
}
